import { BaseEnum } from "../../BaseEnum";

export class FuelType extends BaseEnum {
  static BIOMASS = 1;
  static BIOMASS_FUELS_GASEOUS = 2;
  static BIOMASS_FUELS_KRAFT_PULPING_LIQUOR_BY_WOOD_FURNISH = 3;
  static BIOMASS_FUELS_LIQUID = 4;
  static BIOMASS_FUELS_SOLID = 5;
  static COAL_AND_COKE = 6;
  static GASEOUS_FUELS = 7;
  static LIQUID_FUELS = 8;
  static NATURAL_GAS = 9;
  static OTHER_FUELS_GASEOUS = 10;
  static OTHER_FUELS_SOLID = 11;
  static PETROLEUM_PRODUCTS = 12;
  static SOLID_FUELS = 13;

  static Codes = [
    this.BIOMASS,
    this.BIOMASS_FUELS_GASEOUS,
    this.BIOMASS_FUELS_KRAFT_PULPING_LIQUOR_BY_WOOD_FURNISH,
    this.BIOMASS_FUELS_LIQUID,
    this.BIOMASS_FUELS_SOLID,
    this.COAL_AND_COKE,
    this.GASEOUS_FUELS,
    this.LIQUID_FUELS,
    this.NATURAL_GAS,
    this.OTHER_FUELS_GASEOUS,
    this.OTHER_FUELS_SOLID,
    this.PETROLEUM_PRODUCTS,
    this.SOLID_FUELS,
  ];

  static _labelKeys = [
    "enums.fuel-type.BIOMASS",
    "enums.fuel-type.BIOMASS_FUELS_GASEOUS",
    "enums.fuel-type.BIOMASS_FUELS_KRAFT_PULPING_LIQUOR_BY_WOOD_FURNISH",
    "enums.fuel-type.BIOMASS_FUELS_LIQUID",
    "enums.fuel-type.BIOMASS_FUELS_SOLID",
    "enums.fuel-type.COAL_AND_COKE",
    "enums.fuel-type.GASEOUS_FUELS",
    "enums.fuel-type.LIQUID_FUELS",
    "enums.fuel-type.NATURAL_GAS",
    "enums.fuel-type.OTHER_FUELS_GASEOUS",
    "enums.fuel-type.OTHER_FUELS_SOLID",
    "enums.fuel-type.PETROLEUM_PRODUCTS",
    "enums.fuel-type.SOLID_FUELS",
  ];
}
